// Formats one tracking entry as "Category: Option", falling back to whichever
// part is present.
export function formatTrackingEntry(entry) {
    var _a, _b;
    const category = (_a = entry.trackingCategory) === null || _a === void 0 ? void 0 : _a.trim();
    const option = (_b = entry.option) === null || _b === void 0 ? void 0 : _b.trim();
    if (category && option) {
        return `${category}: ${option}`;
    }
    return option || category || ``;
}
// A single line's tracking, joined: "Region: North, Department: Sales".
export function formatLineTracking(tracking) {
    if (!(tracking === null || tracking === void 0 ? void 0 : tracking.length)) {
        return ``;
    }
    return tracking.map(formatTrackingEntry).filter(Boolean).join(`, `);
}
// The unique set of tracking labels across all of an invoice's line items.
export function extractUniqueTrackingLabels(lineItems) {
    if (!(lineItems === null || lineItems === void 0 ? void 0 : lineItems.length)) {
        return [];
    }
    const labels = new Set();
    for (const lineItem of lineItems) {
        for (const entry of lineItem.tracking || []) {
            const label = formatTrackingEntry(entry);
            if (label) {
                labels.add(label);
            }
        }
    }
    return [...labels];
}
//# sourceMappingURL=invoiceTrackingUtils.js.map